module.exports = __webpack_public_path__ + "static/img/f12.07431d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/f12.png
// module id = NHNI
// module chunks = 0